import {
    Avatar,
    Box,
    Button,
    Modal,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Input,
    ListItem,
    ListItemText,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
  import { Link, Navigate, useNavigate } from "react-router-dom";
  import bgImage from '../../images/support_system_bg_mafi_technologies.jpg';
  import CircularProgress from '@mui/material/CircularProgress';
import { trmGet } from "../../services/trmService";
  
  const tableStyle = "w-full border-collapse text-left";
  const headerCellStyle = "bg-gray-200 border text-gray-700 font-semibold py-2 px-4";
  const cellStyle = "border py-2 px-4";
  const rowStyle = "hover:bg-gray-100 cursor-pointer";

  const APIKEY = '49B58DDDA9914574B2E94830CAF6FFD1';

  const onLoading = () => {
    return (
      <Box className="w-full h-full flex items-center justify-center bg-black bg-opacity-20">
        <CircularProgress color="warning" />
      </Box>
    )
  }
  
  function ProductModal({ product, onClose }) {
    const navigate = useNavigate();
    const [trm, setTrm] = useState(localStorage.getItem('trm'))
    const handleSendToCart = () => {
      // Obtén la lista actual de productos del localStorage
      const existingProducts = JSON.parse(localStorage.getItem("cart")) || [];

      // Agrega el nuevo producto a la lista
      product.price.value = parseInt((((parseInt(product.price.value))+1)*trm)*1.1);
      const updatedProducts = [...existingProducts, product];

      // Guarda la lista actualizada en el localStorage
      localStorage.setItem("cart", JSON.stringify(updatedProducts));
      navigate('/cart', { state: { product: product } }); // Establece el producto seleccionado en Dashboard
      onClose(); // Cierra el modal al enviar el producto al carrito
    };

    return (
      <Modal open={true} onClose={onClose}>
        <Box className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-72 bg-white p-4 rounded-lg">
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              fontSize: "1.5rem",
              marginBottom: "0.5rem",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "200px",
            }}
          >
            {product.title}
          </Typography>
          {product.price && (
            <Typography variant="body2" sx={{ fontSize: "0.875rem", marginBottom: "0.25rem" }}>
              {/* Price: {((parseInt(parseInt(product.price.value.slice(0,-3).replace('$', '').replace(",", ""))+1)*trm)*1.10).toLocaleString()} {product.price.currency} */}
              Price: $ {(parseInt((((parseInt(product.price.value))+1)*trm)*1.1)).toLocaleString()}
            </Typography>
          )}
          {product.rating && (
            <Typography variant="body2" sx={{ fontSize: "0.875rem", marginBottom: "0.25rem" }}>
              Rating: {product.rating}
            </Typography>
          )}
          <Typography variant="body2" sx={{ fontSize: "0.875rem", marginBottom: "0.5rem" }}>
            Category: {product.categories[0].name || product.categories[0].categoryName}
          </Typography>
          <img 
          src={
            !product.image
              ? 'Imagen no disponible'
              : product.image.imageUrl
              ? product.image.imageUrl
              : product.image
          }
          alt={product.title} className="w-full rounded" />
          <Box className="flex flex-row justify-center items-center mt-4">
              <Button
                onClick={handleSendToCart}
                sx={{
                  backgroundColor: "#f9b22b",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#e09d21",
                  },
                  margin: "0.5rem 0",
                }}
              >
                Agregar al Carrito
              </Button>
          </Box>
        </Box>
      </Modal>
    );
  }
  
  const Dashboard = () => {
    const [platformSearch , setPlatformSearch] = useState('amazon')
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [selectedProductForCart, setSelectedProductForCart] = useState('amazon'); // Agrega un estado para almacenar el valor de búsqueda
    const [trm, setTrm] = useState(localStorage.getItem('trm'))
  
    const openModal = (product) => {
      setSelectedProduct(product);
      setIsModalOpen(true);
    };
  
    const closeModal = () => {
      setSelectedProduct(null);
      setIsModalOpen(false);
    };

    const fetchDataAmazon = async (product) => {
        // console.log('fetchData')
        // console.log(product)
        setIsLoading(true)
        try {
          const url = `https://api.rainforestapi.com/request?api_key=${APIKEY}&type=search&amazon_domain=amazon.com&search_term=${product}&sort_by=price_high_to_low`;
          
          const response = await fetch(url);
          console.log(response)
          
          if (response.ok) {
            const data = await response.json();
            // console.log('fetchData:', data);
            setProducts(data.search_results);
            setIsLoading(false);
          } else {
            console.error('Error al obtener datos de la API.');
          }
        } catch (error) {
          console.error('Error al realizar la solicitud a la API:', error);
        }
    };

    const fetchDataEbay = async (product) => {
      console.log('fetchDataEbay');
      console.log(product)
      setIsLoading(true);
    
      try {
        const token = 'v^1.1#i^1#I^3#p^1#r^0#f^0#t^H4sIAAAAAAAAAOVYb2wURRTv9Z80WDQBRQjGy2qMSHZv9v7t3do7cm2pFFtauP6jQurs7tx1uf1z3ZmlveCHphHQCIZobKiGpKgxAT8ICV8QSIwhIkQwiBgVEkAQoSbAB7AkgnHurpRrJVDoJTZxv2xm5r037/ebN+/NDOgtLXtx/eL1w+WORwoHe0FvocPBTwdlpSULZhQVzi0pADkCjsHe53qL+4ouVmCoa0lxOcJJ08DI2aNrBhYznSHGtgzRhFjFogF1hEUii9FIfZ3o5oCYtExiyqbGOGurQ4zEuyH0QeR3CwBBb4D2GrdtNpkhxuv2y5IQCwhBGPABmQ5jbKNaAxNokBDjBm4Py/MsLzTxQREERCBwPnewnXG2IAurpkFFOMCEM96KGV0rx9V7ewoxRhahRphwbaQm2hCprV60tKnClWMrPEJDlEBi47GtKlNBzhao2eje0+CMtBi1ZRlhzLjC2RnGGhUjt515CPczTKMY9ChSLCh4pKBfEqS8UFljWjok9/Yj3aMqbCwjKiKDqCR1P0YpG9JqJJOR1lJqorbamf4ts6GmxlRkhZhFlZEVkcZGJhzRUE+9aUE2iqAld7LRyjbWA2W/j8L1sIoS8PlkyTMyTdbWCMnj5qkyDUVNU4adS01SiajPaCwzAdGXwwwVajAarEiMpP3JkXPzowx629NLml1Dm3Qa6VVFOqXBmWnen/9RbUIsVbIJGrUwfiBDUIiByaSqMOMHM5E4Ejw9OMR0EpIUXa7u7m6u28OZVtzlBoB3tdXXReVOpEMmK5ve61Revb8Cq2agyIhqYlUkqST1pYdGKnXAiDNhL88LXvcI72PdCo/v/VdHDmbX2P2Qr/2hIB4Kil+Jub1A8gbzkmrCIyHqSvuBJJhidWglEElqUEasTOPM1pGlKqLHF3N7AjHEKv5gjPUGYzFW8il+lo8hBBCSJDkY+P9sk4kGehTJFiL5ivT8RHnjy7q+ekU0VqM36VKXsCDeAutBXdyAraRBa4adypKurjhIWK2tIDTRvXBX8FWaSplpovPnjYD0Xs8LCYtNTJAyKXhR2UyiRlNT5dTUWmCPpTRCi6Qq7RRtR5Gm0d+koEaSydq85ev8gHygVPFwqPNapf6LCnVXVDgdtlMLVVofUwMwqXLpGsTJpu4y03sd0gNIursj47Xz7oJjhVySneLiNsKEeqLQE+CElVSayjlazpSJq2SLJQUxcRV6u1BsmTzURJmqzFE21XgnwQ80Z89kSJFsLTFxFQVBbVIhqtJLxpQKUIo0C1lVsrcDLoObw2tkzkLYtC16MeIa0sflJjOBDHr8IJapachq4SedeHXdJlDS0FTLwHnIRSocORsV9zmuTBVcvACA2xsAAWFS2OTM6adjqlWQ/NbNB7gDucY+x4QLMh/f59gP+hx7Ch0OIACWXwDmlxY1Fxc9ymCaeTgMDUUyezgVxjia9AxIbAtxCZRKQtUqLHWov/wg38h5CBpcBZ4afQoqK+Kn57wLgXl3Rkr4x2aXuz08DWE+CAJAaAfP3hkt5p8snnX+hXeNT690DJhHX9r2DEA7V7pu/QTKR4UcjpICGrUFnssVH5R+tPz4l2jmvL9n/rl2nlJ9yBtdefzpdT/v7v0+seHcyYr+5nJ2O/PV6wNrlwy+1nh2/oVpzG8lwa2VLclrlw50Fz+x+FL//oOJOVvWza46POToLzx784vEztaFAWlg/ceGse/m2zdPXFDjz5+Yf2QXPmP247fMJYcr13TswsLXbx6c5tblbz48sxcdP427/O88vnVo4d41h4b/GHwvuOMV3+xZ1/uaK4QZ+z57f+PuPR21v7bN0jemqq+2HNm0OcEKzVeHSpZduzH47uD5i1b7jwM7hj6/vK2m7tUt68r2D4vRT9qq9JPHjh64cWzOrb+Gz10/vWHauSvfnpp76juw6Y3NPdsjBat+zy7jPz2c+2SiEwAA';
        const url = `https://api.sandbox.ebay.com/commerce/catalog/v1_beta/product_summary/search?q=${product}&limit=20`;

        const requestOptions = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        };
    
        const response = await fetch(url, requestOptions);
        console.log(response);
    
        if (response.ok) {
          const data = await response.json();
          console.log('fetchDataEbay:', data);
          // Realiza la lógica con los datos recibidos, por ejemplo:
          // setProducts(data.items); // Ajusta según la estructura de la respuesta
          setProducts(data.itemSummaries);
          setIsLoading(false);
        } else {
          console.error('Error al obtener datos de la API.');
        }
      } catch (error) {
        console.error('Error al realizar la solicitud a la API:', error);
      }
    };
  
    const handleSearch = () => {
      if (platformSearch === 'amazon') {
        fetchDataAmazon(searchValue);
      } else {
        fetchDataEbay(searchValue)
      }
    };

    const handleChangePlatform = (event) => {
      setPlatformSearch(event.target.value);
    };
  
    useEffect(() => {
      trmGet().then((response) => {
        console.log(response)
        console.log(response[0].trm_trm_usd)
        localStorage.setItem('trm', response[0].trm_trm_usd)

      })
    }, []);
  
    return (
        <React.Fragment>
                <Box className="w-full flex flex-col justify-start items-center" sx={{backgroundImage: 'url(' + bgImage + ')', backgroundSize: '100%'}}>
                    <Box className="w-2/3 flex justify-around items-center mt-4">
                    <FormControl>
                      <InputLabel>Plataforma</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={platformSearch}
                        label={platformSearch}
                        onChange={handleChangePlatform}
                      >
                        <MenuItem value={'amazon'}>Amazon</MenuItem>
                        {/* <MenuItem value={'ebay'}>Ebay</MenuItem> */}
                      </Select>
                    </FormControl>
                      <Input
                          sx={{
                              width: '50%'
                          }}
                          placeholder="Busque su producto..."
                          value={searchValue}
                          onChange={(e) => setSearchValue(e.target.value)}
                      />
                      <Button
                      sx={{
                          color: "#f9b22b",
                          borderRadius: "0",
                          "&:hover": {
                          backgroundColor: "#f9b22b",
                          color: "#fff",
                          },
                          margin: "0.5rem 0",
                      }}
                      onClick={handleSearch}>Buscar</Button>
                    </Box>
                    <Box className="w-full h-full flex justify-center items-start mt-4">
                      {isLoading ? onLoading() : (
                        <Box className="w-2/3">
                          <TableContainer 
                            className="overflow-y-auto max-h-[500px]"
                            component={Paper}>
                              <Table className={tableStyle}>
                                  <TableHead>
                                  <TableRow>
                                      <TableCell className={headerCellStyle}>Imagen</TableCell>
                                      <TableCell className={headerCellStyle}>Título</TableCell>
                                      <TableCell className={headerCellStyle}>Categoría</TableCell>
                                      <TableCell className={headerCellStyle}>Precio</TableCell>
                                  </TableRow>
                                  </TableHead>
                                  <TableBody className="overflow-y-auto max-h-[250px]">
                                  {products.map((product, index) => (
                                      <TableRow key={index} className={rowStyle} onClick={() => openModal(product)}>
                                      <TableCell className={cellStyle}>
                                      <Avatar
                                        src={
                                          !product.image
                                            ? 'Imagen no disponible'
                                            : product.image.imageUrl
                                            ? product.image.imageUrl
                                            : product.image
                                        }
                                        alt={product.title}
                                      />
                                      </TableCell>
                                      <TableCell className={cellStyle}>{product.title}</TableCell>
                                      <TableCell className={cellStyle}>{product.categories[0].name || product.categories[0].categoryName}</TableCell>
                                      {
                                        product.price ? (

                                          <TableCell className={cellStyle}> $ 
                                            {platformSearch === 'amazon'
                                              ? `${((parseInt(parseInt(product.price.raw.slice(0,-3).replace('$', '').replace(",", ""))+1)*trm)*1.10).toLocaleString()} `
                                              // ? `${product.price.raw}`
                                              : `${product.price.value}`}
                                          </TableCell>
                                        ) : (
                                          <TableCell className={cellStyle}>Precio no disponible</TableCell>
                                        )
                                      }
                                      </TableRow>
                                  ))}
                                  </TableBody>
                              </Table>
                            </TableContainer>
                        </Box>
                      )}
                    </Box>
                    {isModalOpen && selectedProduct && (
                    <ProductModal
                        product={selectedProduct}
                        onClose={closeModal}
                        setSelectedProductForCart={setSelectedProductForCart}
                    />
                    )}
                </Box>
        </React.Fragment>
    );
  };
  
export default Dashboard;
  